import { render, staticRenderFns } from "./userPrize.vue?vue&type=template&id=35e666c1&"
import script from "./userPrize.vue?vue&type=script&lang=js&"
export * from "./userPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports